'use client';

import { useState, useEffect } from 'react';

/**
 * StatusBarOverlay - Gradient blur overlay for iOS Dynamic Island and Samsung status bar
 * 
 * This component creates a frosted glass effect at the top of the screen in PWA mode,
 * adapting to the notch/Dynamic Island height using safe-area-inset-top.
 */
export function StatusBarOverlay() {
  const [isPWA, setIsPWA] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    
    // Detect PWA/standalone mode
    const checkPWA = () => {
      // Check for display-mode: standalone (standard PWA detection)
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      
      // Check for iOS standalone mode (Safari-specific)
      const isIOSStandalone = (window.navigator as any).standalone === true;
      
      // Check for Android standalone mode (Chrome-specific)
      const isAndroidStandalone = window.matchMedia('(display-mode: standalone)').matches &&
                                  !window.navigator.userAgent.includes('Safari');
      
      return isStandalone || isIOSStandalone || isAndroidStandalone;
    };

    setIsPWA(checkPWA());
  }, []);

  // Don't render until mounted (avoid SSR mismatch)
  if (!mounted || !isPWA) {
    return null;
  }

  return (
    <div
      className="status-bar-overlay"
      aria-hidden="true"
    />
  );
}

